import { Button, Flex } from '@chakra-ui/react';
import React from 'react';
import { Navigate } from 'react-router';
import { Link } from 'react-router-dom';

import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { PageTemplate, SectionHeader } from '~/core/routes/dev/PageTemplate';

// Constants
const COMPONENT_ROUTES = [
  './chakra/Alert',
  './chakra/Button',
  './chakra/IconButton',
  './chakra/Progress',
  './chakra/Stepper',
  './chakra/Tag',
  './common-frontend/layout/Layout',
  './common-frontend/tables/Table',
  './common-frontend/Counter',
  './common-frontend/IconButtonV2',
  './common-frontend/MenuTree',
  './common-frontend/Timestamp',
  './common-frontend/Typography',
  './common-frontend/UserDetail',
  './common-frontend/InputsBETA',
  './common-frontend/AttributeInput',
] as const;

// Exports
export const Route = () => (
  <RouteErrorBoundary
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <Navigate to="/" />;
    }}
  >
    <PageTemplate title="Dev Home">
      <SectionHeader>UI components</SectionHeader>
      <Flex direction="column" gap="0.5rem">
        {COMPONENT_ROUTES.map((to) => (
          <p key={to}>
            <Button as={Link} colorScheme="v2-aurora" variant="link" to={to}>
              {to}
            </Button>
          </p>
        ))}
      </Flex>
    </PageTemplate>
  </RouteErrorBoundary>
);
